import { Button } from "@/components/ui/button";
import { Card } from "@/components/ui/card";
import {
  Form,
  FormControl,
  FormField,
  FormItem,
  FormLabel,
  FormMessage,
} from "@/components/ui/form";
import { Input } from "@/components/ui/input";
import Loader from "@/components/utils/loader";
import { zodResolver } from "@hookform/resolvers/zod";
import { useRef, useState } from "react";
import { useForm } from "react-hook-form";
import { useTranslation } from "react-i18next";
import { z } from "zod";

const formSchema = z.object({
  name: z.string().min(1, { message: "This field is required" }),
});

const CreateRoleForm = ({ onCreate, onClose }) => {
  const { t } = useTranslation();
  const [loading, setLoading] = useState(false);
  // Guard síncrono contra dobles envíos: el estado `loading` llega tarde para una ráfaga
  // de clicks en el mismo tick y provocaba roles duplicados con un doble click.
  const submittingRef = useRef(false);

  const form = useForm({
    resolver: zodResolver(formSchema),
    defaultValues: {
      name: "",
    },
  });

  const onSubmit = async (values) => {
    if (submittingRef.current) {
      return;
    }
    submittingRef.current = true;
    setLoading(true);
    try {
      await onCreate({ name: values.name });
      form.reset({ name: "" });
      onClose?.();
    } finally {
      submittingRef.current = false;
      setLoading(false);
    }
  };

  return (
    <section className="w-full flex justify-center">
      <Card className="p-6 w-full bg-slate-50">
        <Form {...form}>
          <form onSubmit={form.handleSubmit(onSubmit)}>
            <FormField
              control={form.control}
              name="name"
              render={({ field }) => (
                <FormItem className="mb-4">
                  <FormLabel>{t("forms.roles.name")}</FormLabel>
                  <FormControl>
                    <Input {...field} />
                  </FormControl>
                  <FormMessage />
                </FormItem>
              )}
            />
            <Button type="submit" disabled={loading} className="mt-4 bg-primary hover:bg-primary-600">
              {loading ? <Loader style={"buttonLoader"} /> : t("buttonTexts.create")}
            </Button>
          </form>
        </Form>
      </Card>
    </section>
  );
};

export default CreateRoleForm;
